import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { graphql, useStaticQuery, Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
// import fitsYourSpace from 'src/gifs/introducing-cal-max.gif'
import Analytics from 'src/utils/Analytics'
// import Quiz from '../Quiz'
// import Confessions from '../Confessions'
import StoreContext from '../../context/StoreContext'

import {
  // CalMaxContainer,
  Frame2Container,
  Container,
  Heading,
  Description,
  Card,
  CtaContainer,
  LogoContainer,
  TextContainer,
  CardLink,
  BuyNowLinkCTA,
  // PressContainer,
  // PressIcon,
  Flexbox,
  // ImageContainer,
  ProductContainer,
} from './styles'
// import { BUY_LINK, CAL_BUY_LINK, FRAME_2_BUY_LINK } from '../../utils/constants'
import { BUY_LINK, CAL_BUY_LINK, VIP_CODE } from '../../utils/constants'

const HomepageProducts = ({ inSeasonalState }) => {
  const { frameProduct, calendarProduct, hearth, mdFrameProduct } = useStaticQuery(graphql`
    query HomepageProductsQuery {
      frameProduct: file(relativePath: { eq: "homepage/frame-suite.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      mdFrameProduct: file(relativePath: { eq: "md2026/frame_hp_desk.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      calendarProduct: file(relativePath: { eq: "calendar/calendar-15-usa.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      hearth: file(relativePath: { eq: "skylight-calendar-hearth-and-hand.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
    }
  `)
  const productDetails = [
    {
      image: frameProduct,
      alt: 'Skylight Frame with a picture of a baby in grass',
      link: BUY_LINK,
      name: 'Skylight Frame',
      text: 'Share photos and videos with loved ones anytime, from anywhere.',
      ctaText: 'Shop Frame',
      analytics: 'Clicked Shop Frame in Features CTA',
    },
    {
      image: calendarProduct,
      alt: 'Skylight Calendar on schedule display view',
      link: CAL_BUY_LINK,
      name: 'Skylight Calendar',
      text: `Display all of your calendars on one touchscreen device.`,
      ctaText: 'Shop Calendar',
      analytics: 'Clicked Shop Calendar in Features CTA',
    },
  ]
  // const pressLinks = [
  //   {
  //     id: 'verge',
  //     href: 'https://www.theverge.com/2024/1/30/24054438/skylight-cal-max-smart-family-calendar-launch-pricing',
  //     image: verge.childImageSharp.gatsbyImageData,
  //     alt: 'Verge logo',
  //   },
  //   {
  //     id: 'gma',
  //     href: 'https://www.goodmorningamerica.com/shop/story/back-school-essentials-organizers-label-makers-helpful-finds-113101428',
  //     image: gma.childImageSharp.gatsbyImageData,
  //     alt: 'Good Morning America logo',
  //   },
  // ]

  const frame2DataMap = {
    // bau: {
    //   frameImage: bfcmFrameProduct.childImageSharp.gatsbyImageData,
    //   frameAlt: 'Frame 2 Snap Frame swapping on the Skylight Frame',
    //   frameCtaText: 'Buy Now',
    //   frameCtaLink: FRAME_2_BUY_LINK,
    //   frameHeading: 'Share Photos with Frame 2 ',
    //   frameText:
    //     'With a stunning anti-glare touchscreen display in Full HD, the updated Frame is easy to love. Send photos from your phone, and customize your look with swappable Snap Frames. ',
    // },
    vip: {
      frameImage: mdFrameProduct.childImageSharp.gatsbyImageData,
      frameAlt: 'Collection of Skylight Frames displayed for comparison',
      frameCtaText: 'Buy Now',
      frameCtaLink: BUY_LINK,
      frameHeading: 'Gift the Moments That Move Her',
      frameText:
        'Keep the memories rolling all year long with digital photo and video slideshows in every size and style.',
    },
  }

  const {
    store: { banner },
  } = useContext(StoreContext)

  const isVIPState = banner?.promoCode === VIP_CODE && !inSeasonalState

  // const frameData = inSeasonalState || isVIPState ? frame2DataMap.vip : frame2DataMap.bau
  const { frameImage, frameAlt, frameCtaText, frameCtaLink, frameHeading, frameText } =
    frame2DataMap.vip
  return (
    <>
      {(isVIPState || inSeasonalState) && (
        <ProductContainer sunshine>
          <Frame2Container sunshine>
            <GatsbyImage image={frameImage} alt={frameAlt} />
            <Flexbox>
              <Heading>{frameHeading}</Heading>
              <Description>{frameText}</Description>
              <CtaContainer>
                <Link
                  onClick={() =>
                    Analytics.track('Clicked Homepage Frame 2 Buy Now in Features CTA')
                  }
                  to={frameCtaLink}
                >
                  <BuyNowLinkCTA>{frameCtaText}</BuyNowLinkCTA>
                </Link>
              </CtaContainer>
            </Flexbox>
          </Frame2Container>
        </ProductContainer>
      )}
      <ProductContainer>
        {/* <CalMaxContainer>
          <Flexbox>
            <Heading>Bigger & Bolder: Calendar Max</Heading>
            <Description>
              Experience all the beloved features of our 10" and 15" Calendars on a larger
              high-resolution display tailor-made for dynamic family life.
            </Description>
            <CtaContainer>
              <Link
                onClick={() => Analytics.track('Clicked Preorder Cal Max in Features CTA')}
                to="/products/skylight-calendar-max/"
              >
                <BuyNowLinkCTA>Buy Now</BuyNowLinkCTA>
              </Link>
            </CtaContainer>
          </Flexbox>
          <ImageContainer>
            <img
              src={fitsYourSpace}
              alt="Skylight Calendar turns into a screensaver"
              width="100%"
            />
          </ImageContainer>
        </CalMaxContainer> */}
        <Frame2Container>
          <GatsbyImage
            image={hearth.childImageSharp.gatsbyImageData}
            alt="Skylight Calendar x Hearth & Hand™ partnership with Magnolia"
          />
          <Flexbox>
            <Heading>Skylight Calendar x Hearth & Hand™ with Magnolia</Heading>
            <Description>
              Explore the new collaboration, featuring a vintage-inspired aged brass frame.
            </Description>
            <CtaContainer>
              <Link
                onClick={() => Analytics.track('Clicked Homepage Hearth & Hand Learn More CTA')}
                to="/landing/hearth-hand"
              >
                <BuyNowLinkCTA>Learn More</BuyNowLinkCTA>
              </Link>
            </CtaContainer>
          </Flexbox>
        </Frame2Container>
      </ProductContainer>
      {/* {!IN_SEASONAL_STATE && <Quiz hideImage homepage />} */}
      {/* <Confessions /> */}
      <Heading padding>Explore Our Products</Heading>
      <Container>
        {productDetails.map((product, i) => (
          <CardLink onClick={() => Analytics.track(product.analytics)} to={product.link} key={i}>
            <Card>
              <LogoContainer id={i} calendar={i === 1}>
                <GatsbyImage
                  image={product.image.childImageSharp.gatsbyImageData}
                  alt={product.alt}
                />
              </LogoContainer>
              <TextContainer>
                <Heading>{product.name}</Heading>
                <Description>{product.text}</Description>
                <CtaContainer>
                  <BuyNowLinkCTA>{product.ctaText}</BuyNowLinkCTA>
                </CtaContainer>
              </TextContainer>
            </Card>
          </CardLink>
        ))}
      </Container>
    </>
  )
}

export default HomepageProducts

HomepageProducts.propTypes = {
  inSeasonalState: PropTypes.bool,
}
